<!-- 新闻详情页 -->
<template>
  <div id="mediumDetail">
    <Header></Header>
    <div class="new-breadcrumb">
      <NewBreadcrumb></NewBreadcrumb>
    </div>
    <div class="medium-box">
      <div id="img-content" class="rich_media_wrp">
        <h1 class="rich_media_title" id="activity-name">
          <!-- “创新加速，智享未来”麓山病理AI创新发展高峰论坛圆满召开 -->
          {{ newsInfo.title }}
        </h1>
        <div class="news-content" v-html="newsInfo.content"></div>
      </div>
    </div>
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>
    
<script>
import api from "../../../api/api";
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import NewBreadcrumb from "../../components/NewBreadcrumb.vue";
export default {
  name: "mediumDetail",
  props: {},
  components: {
    Header,
    Footer,
    NewBreadcrumb,
  },
  data() {
    return {
      newsInfo: {},
    };
  },
  created() {
    let id = this.$route.params.id;
    // console.log(id);
    this.getNewsDetail(id);
  },
  mounted() {},
  watch: {},
  methods: {
    getNewsDetail(id) {
      api
        .getNewsById(id)
        .then((res) => {
          console.log(res.data);
          this.newsInfo = res.data.models[0];
        })
        .catch((error) => {});
    },
  },
};
</script>
    
<style lang="scss">
#mediumDetail {
  padding-top: 6.5rem;
  .new-breadcrumb {
  
  }
  .medium-box {
    position: relative;
    width: 100%;
    padding: 1.25rem;
    // padding-top: 5rem;
    margin: auto;
    .rich_media_title {
      font-size: 1.375rem;
      // line-height: 1.4;
      margin-bottom: 1rem;
      text-align: center;
    }
    .news-content {
      // white-space: pre-wrap;
      font-family: "Microsoft Yahei";
      font-size: 1.125rem;
      color: #333;
      p {
        line-height: 2;
      }
    }
  }
  .footer {
    background: #f5f5f5;
  }
  .news-content {
    img {
      max-width: 100%;
      display: block;
      margin: 20px auto;
      width: 100%;
      height: inherit;
    }
    // p {
    //   font-family: "OPlusSans3-Regular";
    // }
    .ql-align-left {
      text-align: left;
    }
    .ql-align-center {
      text-align: center;
    }
    .ql-align-right {
      text-align: right;
    }
  }
}
</style>